<template>
  <div ref="guide" class="guide-popper">
    <a-modal
      :visible="isPopperShown"
      :footer="null"
      centered
      :get-container="() => ($refs.guide as HTMLElement)"
      :closable="isStandardScreen"
      @cancel="cancelPopper"
    >
      <template #closeIcon>
        <img class="icon-close" src="@assets/svgs/preload-icon-popper-close.svg" alt="" />
      </template>
      <component
        :is="getComponent(currentGuideType)"
        v-if="isPopperShown"
        :device-id="currentDeviceId"
        :pull-up-device-state="pullUpDeviceState"
        @cancel="cancelPopper"
      ></component>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
  import type { Ref } from 'vue'
  import { ref } from 'vue'
  import { INSTANCE as GuideManager, GuideType } from '@core/GuideManager'
  import AddingDeviceGuide from '../settings/AddingDeviceGuide.vue'
  import PullUpDeviceGuide from '@/components/pullUpDeviceGuide/PullUpDeviceGuide.vue'
  import type { PullUpDeviceState } from '@/core/DevicePull/DevicePullUpTask'
  import { useSharedScreen } from '@/core/compositions/Screen'

  const { isStandardScreen } = useSharedScreen()
  // todo: 后续封装modal统一closeIcon

  const isPopperShown = ref<boolean>(false)
  const pullUpDeviceState: Ref<PullUpDeviceState | undefined> = ref(undefined)
  const currentDeviceId = ref<string>()
  const currentGuideType: Ref<GuideType | undefined> = ref(undefined)

  const cancelPopper = () => {
    isPopperShown.value = false
  }

  const getComponent = (type: GuideType | undefined) => {
    switch (type) {
      case GuideType.NO_DEVICE:
        return AddingDeviceGuide

      case GuideType.NO_CONNECTION:
        return PullUpDeviceGuide
      default:
        break
    }
  }

  GuideManager.setChangeListener({
    onShowGuide(guideType: GuideType, deviceId?: string, pullUpConfigState?: PullUpDeviceState) {
      currentDeviceId.value = deviceId
      currentGuideType.value = guideType
      pullUpDeviceState.value = pullUpConfigState

      if (guideType === GuideType.NO_CONNECTION && deviceId) {
        isPopperShown.value = true
      } else if (guideType === GuideType.NO_DEVICE) {
        isPopperShown.value = true
      }
    },
  })
</script>

<style lang="stylus" scoped>
  .guide-popper
    :deep(.ant-modal)
      width content_modal_width
    :deep(.ant-modal-content)
      background #ffffff
      box-shadow 0px 3.27652px 24.5739px rgba(0, 0, 0, 0.05)
      border-radius 16px
      overflow hidden
    :deep(.ant-modal-body)
      padding 0px
    .icon-close
      icon-popper-close()

  @import '../styles/h5Adaptive/GuidePopperComponent.styl'
</style>
